import { InjectionToken } from '@angular/core';
import { Routes } from '@angular/router';

/**
 * Factory that returns the localized routes for a given locale.
 */
export type LocalizedRoutesFactory = (localeId: string) => Routes;

/**
 * DI token for the active app's localized routes. Consumed by
 * LocalizedRouteService to build the routeId → locale → path mapping used when
 * switching language. Each app provides its own factory (user → LocalizedAppRoutes,
 * admin → AdminLocalizedAppRoutes). Defaults to an empty route set so the service
 * degrades gracefully (fallback to the plain locale root) if none is provided.
 */
export const LOCALIZED_APP_ROUTES = new InjectionToken<LocalizedRoutesFactory>('LOCALIZED_APP_ROUTES', {
  providedIn: 'root',
  factory: () => () => [],
});
